export default "__VITE_ASSET__CI_jMZt4__"